import { useQuery } from "react-query"
import { Product } from "../enums"
import axios from "axios"
import { DiscountOverview } from "../dtos"

const baseUrl = process.env.PUBLIC_URL
const apiUrl = process.env.REACT_APP_SUPERVIZOR_API
const url = `${baseUrl}/${apiUrl}`

export const useGetDiscountsOverview = (product: Product) => {
    return useQuery(["discountsOverview", product], () =>
        axios.get<DiscountOverview>(`${url}/GetDiscountsOverview`, { params: { product } }))
}
